var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_57_219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.783 22.3483L31.5831 16.1483C31.2939 15.8591 30.8248 15.8591 30.5355 16.1483L27.5267 19.1572C27.2374 19.4465 27.2374 19.9155 27.5267 20.2048L28.0934 20.7714L26.5087 20.9103C26.3339 20.9256 26.1638 20.9616 25.9996 21.0164C25.8358 20.9617 25.6653 20.9256 25.4913 20.9103L23.9066 20.7714L24.4732 20.2048C24.7625 19.9155 24.7625 19.4465 24.4732 19.1572L21.4644 16.1483C21.1752 15.8591 20.7061 15.8591 20.4168 16.1483L14.2169 22.3483C13.9277 22.6375 13.9277 23.1066 14.2169 23.3959L17.2258 26.4047C17.5149 26.6939 17.9842 26.694 18.2734 26.4047L18.9436 25.7345L19.0822 27.3188C19.1275 27.8385 19.3558 28.3279 19.7247 28.6967L24.186 33.1575C25.4106 34.3821 26.7037 34.2678 27.5407 33.4309C27.9374 33.0342 32.2593 28.7129 32.2756 28.6965C32.6444 28.3276 32.8725 27.8384 32.9179 27.3188L33.0564 25.7345L33.7267 26.4047C34.0158 26.6938 34.485 26.6939 34.7742 26.4047L37.7831 23.3958C38.0723 23.1066 38.0723 22.6375 37.783 22.3483ZM17.7496 24.8334L15.7883 22.8721L20.9407 17.7197L22.9019 19.681C16.683 25.8999 18.2714 24.3115 17.7496 24.8334ZM30.5556 28.319C30.5555 28.3191 30.5554 28.3192 30.5553 28.3193C30.2835 28.5913 29.8435 28.5914 29.5711 28.319C29.5706 28.3185 29.5701 28.3181 29.5696 28.3177L28.3868 27.1348C28.0975 26.8455 27.6285 26.8456 27.3392 27.1348C27.05 27.4241 27.05 27.8931 27.3392 28.1824L28.5235 29.3667C28.5238 29.3669 28.524 29.3671 28.5243 29.3673C28.7955 29.6394 28.7962 30.079 28.5233 30.3513C28.2516 30.6233 27.8114 30.6235 27.539 30.3511C27.5386 30.3508 27.5383 30.3505 27.538 30.3502L26.3547 29.1669C26.0654 28.8776 25.5964 28.8776 25.3071 29.1669C25.0178 29.4562 25.0178 29.9252 25.3071 30.2145L26.4914 31.3988C26.4915 31.3989 26.4917 31.399 26.4919 31.3992C26.7623 31.6703 26.7653 32.1099 26.4907 32.3839C26.3279 32.5471 26.0945 32.6183 25.8661 32.5745C25.6172 32.5268 25.5291 32.4055 25.2334 32.1099L20.772 27.6491C20.6491 27.5261 20.573 27.363 20.5579 27.1898L20.311 24.3671C20.6206 24.0575 22.0449 22.6328 22.5392 22.1388L25.3619 22.3861C25.535 22.4013 25.6979 22.4773 25.8207 22.6C26.9048 23.6837 30.2763 27.0553 30.5552 27.3343C30.8268 27.606 30.8269 28.0477 30.5556 28.319ZM31.5276 26.2114C31.2957 25.9794 28.7548 23.4385 27.6165 22.3005L29.4606 22.1389C29.9873 22.6652 31.533 24.2114 31.6888 24.3672L31.5276 26.2114ZM34.2504 24.8334C33.5566 24.1396 29.2513 19.8343 29.098 19.681L31.0593 17.7198L36.2117 22.872L34.2504 24.8334Z",
    fill: "#101828"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_57_219",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57_219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57_219",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/Sustainability.8630031a44b8aac19f7289999d23e3f1.svg";
export { ForwardRef as ReactComponent };